/*eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Table,
  Dropdown,
  Input,
} from "semantic-ui-react";
import {
  Form as Formiker,
  Field as Fieldmik,
  FieldArray,
  Formik,
  getIn,
} from "formik";
import { MyInput, MyNormalInput } from "../dynamicComponent/myInputs";
import { connect } from "react-redux";
import { createShipmentDispatcher } from "../../redux/actions/shipmentAction";
import ReadAxios from "../axiosComponent/read";
import * as yup from "yup";
import ErrorMessages from "./ErrorMessages";
import { successAlertDispatcher } from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import MandatoryMark from "../common/mandatorymark";
import { DateData } from "../dynamicComponent/datepick";
import DropLocation from "../dynamicComponent/locationDrop";
import ModalCreateConsignee from "./modalCreateConsignee";
import ModalCreateConsignor from "./modalCreateConsigner";

const ModalEditJobOrder = (props) => {
  const getIntialCall = async () => {
    let [consigneeArray, consignorsArray, productsArray, dataArray, vendorArray] = await Promise.all([
      ReadAxios({ url: "consigneeMaster" }),
      ReadAxios({ url: "consignorMaster" }),
      ReadAxios({ url: "skuMaster" }),
      ReadAxios({ url: `vehicleTypeMaster` }),
      ReadAxios({ url: `transporterMaster` })
    ]);
    consigneeArray = isEmpty(consigneeArray) ? [] : consigneeArray.data.resultSet;
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    vendorArray = isEmpty(vendorArray) ? [] : vendorArray.data.resultSet;
    consignorsArray = isEmpty(consignorsArray) ? [] : consignorsArray.data.resultSet;
    productsArray = isEmpty(productsArray) ? [] : productsArray.data.resultSet;
    if (consigneeArray)
      setconsignees(
        consigneeArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.consigneeCode + " " + item.consigneeName,
            value: item.consigneeCode,
            raw: { ...item },
          };
        })
      );

    if (dataArray)
      setvehicletype(
        dataArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.vehicleType,
            value: item.vehicleTypeId,
            raw: { ...item },
          };
        })
      );

    if (vendorArray)
      setVendor(
        vendorArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.transporterName,
            value: item.transporterMasterId,
            raw: { ...item },
          };
        })
      );

    if (consignorsArray)
      setconsignors(
        consignorsArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.consignorCode + " " + item.consignorName,
            value: item.consignorCode,
            raw: { ...item },
          };
        })
      );

    if (productsArray) {
      setproducts(
        productsArray.map((item, index) => {
          return {
            key: index + 1,
            text: item.skuCode,
            value: item.skuCode,
            raw: { ...item },
          };
        })
      );
    }
  };

  const [consignees, setconsignees] = useState([]);
  const [consignors, setconsignors] = useState([]);
  const [products, setproducts] = useState([]);
  const [vehicles, setvehicletype] = useState([]);
  const [vendors, setVendor] = useState([]);

  useEffect(() => {
    console.log(props);
    getIntialCall();
  }, []);

  // const handleOpenConsignorModal = () =>{
  //   console.log('here');

  //   console.log(modalConsignor);
  // }

  // let handleOpenConsignorModal = () => setModalConsignorOpen(true);

  // let handleCloseConsignorModal = () => {
  //   setModalConsignorOpen(false);
  //   // if (values.vendor) handleSubmit();
  // };

  const addNewDelivery = (arrayHelpers) => {
    if (props.shipment.create.movement_type == "import") {
      if (props.shipment.create.no_of_vehicles <= arrayHelpers.form.values.deliveries.length) {
        console.log('container number is less than deliveries');
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Warning",
          messageBody: "Can not create more Deliveries then required containers.",
        });
      } else {
        arrayHelpers.push({
          delivery_number: "",
          delivery_reference_no: "",
          consignor_code: "",
          consignee_code: "",
          min_temp: null,
          max_temp: null,
          container_no: "",
          container_pickup_date: "",
          container_return_date: "",
          products: [
            {
              product_code: "",
              product_name: "",
              quantity: "",
              product_category_id: "",
              packaging_type_id: "",
            },
          ],
          invoices: [
            {
              invoice_no: "",
              invoice_date: "",
              invoice_quantity: "",
              tracking_number: "",
              bl_no: ""
            }
          ],
        })
      }
    } else {
      arrayHelpers.push({
        delivery_number: "",
        delivery_reference_no: "",
        consignor_code: "",
        consignee_code: "",
        min_temp: null,
        max_temp: null,
        container_no: "",
        container_pickup_date: "",
        container_return_date: "",
        products: [
          {
            product_code: "",
            product_name: "",
            quantity: "",
            product_category_id: "",
            packaging_type_id: "",
          },
        ],
        invoices: [
          {
            invoice_no: "",
            invoice_date: "",
            invoice_quantity: "",
            tracking_number: "",
            bl_no: ""
          }
        ],
      })
    }
  }

  const decideInitialValue =
    props.editOrderIndex !== null
      ? { ...props.editOrderData }
      : {
        // order_number: "",
        order_reference_no: "",
        gross_weight: "",
        net_weight: 1,
        proposed_vehicle_type: "",
        proposed_vehicle_type_name: "",
        vendor_id: undefined,
        freight_rate: "",
        deliveries: [
          {
            delivery_number: "",
            delivery_reference_no: "",
            consignor_code: "",
            consignee_code: "",
            min_temp: null,
            max_temp: null,
            container_no: null,
            container_pickup_date: null,
            container_return_date: null,
            container_drop_location: null,
            storage_expiration_date: null,
            demurrage_expiration_date: null,
            ata_date: null,
            products: [
              {
                product_code: null,
                product_name: null,
                quantity: null,
                product_category_id: null,
                packaging_type_id: null,
              },
            ],
            invoices: [
              {
                invoice_no: null,
                invoice_date: null,
                invoice_quantity: null,
                tracking_number: null,
                bl_no: null
              }
            ],
          },
        ],
      };

  if (props.values.values.movement_type == "import") {
    var validationSchema = yup.object().shape(
      {
        // order_number: yup.string().optional(),
        order_reference_no: yup.string().optional(),
        gross_weight: yup
          .number()
          .required("required")
          .min(1, "min")
          .when("net_weight", (net_weight) =>
            net_weight
              ? yup.number().optional().nullable().min(net_weight, "min_net")
              : yup.number().required("required").min(1, "min")
          ),
        net_weight: yup
          .number()
          .required("required")
          .min(1, "min")
          .when("gross_weight", (gross_weight) =>
            gross_weight
              ? yup.number().optional().nullable().max(gross_weight, "max_gross")
              : yup.number().required("required").min(1, "min")
          ),
        proposed_vehicle_type: yup.number().required("required"),
        vendor_id: yup.number().optional(),
        freight_rate: yup.number().optional(),
        deliveries: yup.array().of(
          yup.object().shape(
            {
              delivery_number: yup.string().optional(),
              delivery_reference_no: yup.string().optional(),
              consignor_code: yup.string().required("required"),
              consignee_code: yup.string().required("required"),
              min_temp: yup
                .number()
                .optional()
                .nullable()
                .when("max_temp", (max_temp) =>
                  max_temp
                    ? yup.number().optional().nullable().max(max_temp, "max")
                    : yup.number().optional().nullable()
                ),
              max_temp: yup
                .number()
                .optional()
                .nullable()
                .when("min_temp", (min_temp) =>
                  min_temp
                    ? yup.number().optional().nullable().min(min_temp, "min")
                    : yup.number().optional().nullable()
                ),
              container_no: yup.string().optional().nullable(),
              container_pickup_date: yup
                .string()
                .optional()
                .nullable(),
              // .when("container_return_date", (container_return_date) =>
              //   container_return_date
              //     ? yup.string()
              //       .optional()
              //       .nullable()
              //       .max(container_return_date, "max")
              //     : yup.string().optional().nullable()
              // ),
              // props.values.values.movement_type: yup.string(),
              container_return_date: yup.string().optional().nullable(),
              container_drop_location: yup.string().optional().nullable(),
              storage_expiration: yup.string().optional().nullable(),
              demurrage_expiration: yup.string().optional().nullable(),
              // ata_date: yup.string().when("container_return_date", {
              //   is: (value) => value,
              //   then: yup.string().required('Required').nullable(), otherwise: yup.string().optional().nullable()
              // }),
              ata_date: yup.string().optional().nullable().required("required"),
              products: yup.array().of(
                yup.object().shape({
                  // product_code: yup.string().required("required"),
                  product_code: yup.string().optional().nullable(),
                  product_name: yup.string().optional().nullable(),
                  product_category_id: yup.number().optional().nullable(),
                  packaging_type_id: yup.number().optional().nullable(),
                  quantity: yup.number().optional().min(1, "min").nullable(),
                  // quantity: yup.number().required("required").min(1, "min"),
                })
              ),
              invoices: yup.array().of(
                yup.object().shape({
                  // product_code: yup.string().required("required"),
                  invoice_code: yup.string().optional().nullable(),
                  invoice_date: yup.string().optional().nullable(),
                  invoice_quantity: yup.number().optional().min(1, "min").nullable(),
                  tracking_number: yup.string().optional().nullable(),
                })
              ),
            },
            ["max_temp", "min_temp"]
          )
        ),
      },
      ["net_weight", "gross_weight"]
    );
  } else {
    var validationSchema = yup.object().shape(
      {
        // order_number: yup.string().optional(),
        order_reference_no: yup.string().optional(),
        gross_weight: yup
          .number()
          .required("required")
          .min(1, "min")
          .when("net_weight", (net_weight) =>
            net_weight
              ? yup.number().optional().nullable().min(net_weight, "min_net")
              : yup.number().required("required").min(1, "min")
          ),
        net_weight: yup
          .number()
          .required("required")
          .min(1, "min")
          .when("gross_weight", (gross_weight) =>
            gross_weight
              ? yup.number().optional().nullable().max(gross_weight, "max_gross")
              : yup.number().required("required").min(1, "min")
          ),
        proposed_vehicle_type: yup.number().required("required"),
        vendor_id: yup.number().optional(),
        freight_rate: yup.number().optional(),
        deliveries: yup.array().of(
          yup.object().shape(
            {
              delivery_number: yup.string().optional(),
              delivery_reference_no: yup.string().optional(),
              consignor_code: yup.string().required("required"),
              consignee_code: yup.string().required("required"),
              min_temp: yup
                .number()
                .optional()
                .nullable()
                .when("max_temp", (max_temp) =>
                  max_temp
                    ? yup.number().optional().nullable().max(max_temp, "max")
                    : yup.number().optional().nullable()
                ),
              max_temp: yup
                .number()
                .optional()
                .nullable()
                .when("min_temp", (min_temp) =>
                  min_temp
                    ? yup.number().optional().nullable().min(min_temp, "min")
                    : yup.number().optional().nullable()
                ),
              container_no: yup.string().optional().nullable(),
              container_pickup_date: yup
                .string()
                .optional()
                .nullable(),
              // .when("container_return_date", (container_return_date) =>
              //   container_return_date
              //     ? yup.string()
              //       .optional()
              //       .nullable()
              //       .max(container_return_date, "max")
              //     : yup.string().optional().nullable()
              // ),
              // props.values.values.movement_type: yup.string(),
              container_return_date: yup.string().optional().nullable(),
              container_drop_location: yup.string().optional().nullable(),
              storage_expiration: yup.string().optional().nullable(),
              demurrage_expiration: yup.string().optional().nullable(),
              // ata_date: yup.string().when("container_return_date", {
              //   is: (value) => value,
              //   then: yup.string().required('Required').nullable(), otherwise: yup.string().optional().nullable()
              // }),
              ata_date: yup.string().optional().nullable(),
              products: yup.array().of(
                yup.object().shape({
                  // product_code: yup.string().required("required"),
                  product_code: yup.string().optional().nullable(),
                  product_name: yup.string().optional().nullable(),
                  product_category_id: yup.number().optional().nullable(),
                  packaging_type_id: yup.number().optional().nullable(),
                  quantity: yup.number().optional().min(1, "min").nullable(),
                  // quantity: yup.number().required("required").min(1, "min"),
                })
              ),
              invoices: yup.array().of(
                yup.object().shape({
                  invoice_code: yup.string().optional().nullable(),
                  invoice_date: yup.string().optional().nullable(),
                  invoice_quantity: yup.number().optional().min(1, "min").nullable(),
                  tracking_number: yup.string().optional().nullable(),
                })
              ),
            },
            ["max_temp", "min_temp"]
          )
        ),
      },
      ["net_weight", "gross_weight"]
    );
  }
  return (
    <div>
      <Modal
        open={props.OpenModel}
        size="fullscreen"
        centered={false}
        scrolling="true"
        onClose={props.handleClose}
      >
        <Modal.Header className="p-bold-100">
          { +localStorage.getItem("customerNumber") == 503 ? "All Booking Details" : props.t("title") || "Add Order Details"}
        </Modal.Header>
        <Formik
          //   validationSchema={validationSchema}
          initialValues={decideInitialValue}
          onSubmit={(values) => {
            console.log(values);
            let orders = [];
            let shipments = props.shipment;
            console.log('props.editOrderIndex !== null', props.editOrderIndex);
            if (props.editOrderIndex !== null) {
              // need to update the order
              console.log('props.editOrderIndex !== null');
              shipments.create.orders.splice(props.editOrderIndex, 1, values);
              props.successAlertDispatcher({
                type: "success",
                messageHeader: "Success",
                messageBody: "Order is updated.",
              });
            } else {
              if (
                shipments &&
                shipments.create.orders &&
                shipments.create.orders.length > 0
              ) {
                shipments.create.orders.push(values);
              } else {
                orders.push(values);
                shipments = Object.assign({}, props.shipment.create, {
                  orders,
                });
              }
              props.successAlertDispatcher({
                type: "success",
                messageHeader: "Success",
                messageBody: "New order is created.",
              });
            }
            shipments = shipments.create
              ? { ...shipments.create }
              : { ...shipments };
            props.createShipmentDispatcher(shipments, false);
            props.handleClose();
          }}
          render={({ values, setFieldValue, errors, touched, t }) => {
            const setProductCodeAndProductName = (name, data) => {
              setFieldValue(data.name, data.value);
              setFieldValue(
                data.name.replace("product_code", "product_name"),
                data.options.find((ele) => ele.value == data.value)
                  ? data.options.find((ele) => ele.value == data.value).raw
                    .skuName
                  : ""
              );
            };
            return (
              <Modal.Content scrolling={true}>
                <Modal.Description>
                  <Formiker className="ui form tiny">
                    <FormUi.Group>
                      <FormUi.Field width={4}>
                        <label className="labelName mt-2">
                          {props.t("reference_number.title") ||
                            "Reference Number"}{" "}
                          {/* <MandatoryMark /> */}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field
                        width={4}
                        error={
                          touched.order_reference_no &&
                            errors.order_reference_no
                            ? true
                            : false
                        }
                      >
                        <Fieldmik
                          component={MyNormalInput}
                          name="order_reference_no"
                        />
                        {touched.order_reference_no &&
                          errors.order_reference_no ? (
                            <div className="w3-text-red w3-tiny">
                              {props.t(
                                `reference_number.error_msg.${errors.order_reference_no}`
                              ) || errors.order_reference_no}
                            </div>
                          ) : null}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      {/* gross & net weight */}
                      <FormUi.Field width={3}>
                        <label className="labelName mt-2">
                          {props.t("gross_weight.title") || "Gross Weight"}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field
                        width={4}
                        error={
                          touched.gross_weight && errors.gross_weight
                            ? true
                            : false
                        }
                      >
                        <Fieldmik
                          component={MyNormalInput}
                          name="gross_weight"
                          type="number"
                          min={0}
                        />
                        {touched.gross_weight && errors.gross_weight ? (
                          <div className="w3-text-red w3-tiny">
                            {props.t(
                              `gross_weight.error_msg.${errors.gross_weight}`
                            ) || errors.gross_weight}
                          </div>
                        ) : null}
                      </FormUi.Field>
                      <FormUi.Field width={1} />
                      <FormUi.Field width={3}>
                        <label className="labelName mt-2">
                          {props.t("proposed_vehicle_type.title") ||
                            "Proposed Vehicle Type"}{" "}
                          <MandatoryMark />
                        </label>
                      </FormUi.Field>
                      <FormUi.Field
                        width={4}
                        error={
                          touched.proposed_vehicle_type && errors.proposed_vehicle_type
                            ? true
                            : false
                        }
                      >
                        <Dropdown
                          clearable
                          style={{ width: "100%", fontWeight: "normal" }}
                          search
                          selection
                          placeholder={
                            props.t("proposed_vehicle_type.placeholder") ||
                            "Proposed Vehicle Type"
                          }
                          defaultValue={
                            values.proposed_vehicle_type
                          }
                          onChange={(name, data) =>
                            setFieldValue("proposed_vehicle_type", data.value)
                          }
                          options={vehicles}
                        />
                        {touched.proposed_vehicle_type &&
                          errors.proposed_vehicle_type ? (
                            <div className="w3-small w3-text-red">
                              {props.t(
                                `proposed_vehicle_type.error_msg.${errors.proposed_vehicle_type}`
                              ) || errors.proposed_vehicle_type}
                            </div>
                          ) : null}
                      </FormUi.Field>
                      {/* </FormUi.Group> */}
                      {/* <FormUi.Field width={3}>
                        <label className="labelName mt-2">
                          {props.t("net_weight.title") || "Net Weight"}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field
                        width={4}
                        error={
                          touched.net_weight && errors.net_weight ? true : false
                        }
                      >
                        <Fieldmik
                          component={MyNormalInput}
                          name="net_weight"
                          type="number"
                          min={0}
                        />
                        {touched.net_weight && errors.net_weight ? (
                          <div className="w3-text-red w3-tiny">
                            {props.t(
                              `net_weight.error_msg.${errors.net_weight}`
                            ) || errors.net_weight}
                          </div>
                        ) : null}
                      </FormUi.Field> */}
                    </FormUi.Group>
                    <FormUi.Group>
                      <FormUi.Field width={2}>
                        <label className="labelName mt-2">
                          {props.t("vendor.title") ||
                            "Vendor"}{" "}
                          {/* <MandatoryMark /> */}
                        </label>
                      </FormUi.Field>
                      <FormUi.Field
                        width={4}
                        error={
                          touched.vendor && errors.vendor
                            ? true
                            : false
                        }
                      >
                        <Dropdown
                          clearable
                          style={{ width: "100%", fontWeight: "normal" }}
                          search
                          selection
                          placeholder={
                            props.t("vendor.placeholder") ||
                            "Select Vendor"
                          }
                          defaultValue={
                            values.vendor_id
                          }
                          onChange={(name, data) =>
                            setFieldValue("vendor_id", data.value)
                          }
                          options={vendors}
                        />
                        {touched.vendor &&
                          errors.vendor ? (
                            <div className="w3-small w3-text-red">
                              {props.t(
                                `vendor.error_msg.${errors.vendor}`
                              ) || errors.vendor}
                            </div>
                          ) : null}
                      </FormUi.Field>
                      <FormUi.Field width={2} />
                      {values.vendor_id ? (
                        <>
                          <FormUi.Field width={2}>
                            <label className="labelName mt-2">
                              {props.t("final_rate.title") ||
                                "Final Rate"}{" "}
                              {/* <MandatoryMark /> */}
                            </label>
                          </FormUi.Field>
                          <FormUi.Field
                            width={4}
                            error={
                              touched.freight_rate &&
                                errors.freight_rate
                                ? true
                                : false
                            }
                          >
                            <Fieldmik
                              component={MyNormalInput}
                              type="number"
                              name="freight_rate"
                            />
                            {touched.freight_rate &&
                              errors.freight_rate ? (
                                <div className="w3-text-red w3-tiny">
                                  {props.t(
                                    `final_rate.error_msg.${errors.freight_rate}`
                                  ) || errors.freight_rate}
                                </div>
                              ) : null}
                          </FormUi.Field>
                        </>
                      ) : (
                          null
                        )}
                    </FormUi.Group>
                    <FieldArray
                      name="deliveries"
                      render={(arrayHelpers) => (
                        <>
                          {values.deliveries.map((object, index) => (
                            <Table unstackable key={`delivery_form` + index}>
                              <Table.Header>
                                <Table.Row>
                                  <Table.HeaderCell colSpan="5">
                                    "{props.t("delivery_form.title") ||
                                      "Delivery"}{" "}
                                    {index + 1}"
                                  </Table.HeaderCell>
                                  <Table.HeaderCell textAlign="right">
                                    <Button
                                      hidden={index === 0 ? true : false}
                                      size="mini"
                                      basic
                                      color="red"
                                      onClick={() => arrayHelpers.remove(index)}
                                      icon
                                    >
                                      <Icon name="trash" />{" "}
                                      {props.t("delivery_form.title") ||
                                        "Delivery"}
                                    </Button>
                                  </Table.HeaderCell>
                                </Table.Row>
                              </Table.Header>
                              <Table.Body>
                                <Table.Row key={index}>
                                  <Table.Cell>
                                    <Fieldmik
                                      className="text-nowrap"
                                      error={
                                        getIn(
                                          errors,
                                          `deliveries[${index}].delivery_reference_no`
                                        ) &&
                                          getIn(
                                            touched,
                                            `deliveries[${index}].delivery_reference_no`
                                          )
                                          ? true
                                          : false
                                      }
                                      component={MyInput}
                                      style={{ paddingTop: "5.5px" }}
                                      label={
                                        props.shipment.create.movement_type !=
                                          "import"
                                          ? props.t(
                                            "delivery_form.reference_number.title"
                                          ) || "Delivery Reference Number *"
                                          : props.t(
                                            "delivery_form.reference_number.invoice_number"
                                          ) || "Delivery Reference Number *"
                                      }
                                      name={`deliveries[${index}].delivery_reference_no`}
                                    />
                                    {
                                      <ErrorMessages
                                        name={`deliveries[${index}].delivery_reference_no`}
                                        trans={"delivery_form.reference_number"}
                                      />
                                    }
                                  </Table.Cell>
                                  <Table.Cell>
                                    <label className="labelName">
                                      {props.moment == "import" ? (
                                        <>
                                          {props.t(
                                            "delivery_form.port_terminal.title"
                                          ) || "Port Terminal"}{" "}
                                          <MandatoryMark />
                                        </>
                                      ) : (
                                          <>
                                            {props.t(
                                              "delivery_form.consignor.title"
                                            ) || "Consignor"}{" "}
                                            <MandatoryMark />
                                          </>
                                        )}
                                    </label><br></br>
                                    <div className="ui action input">
                                      <Dropdown
                                        labeled={true}
                                        name={`deliveries[${index}].consignor_code`}
                                        clearable
                                        style={{ width: "100%" }}
                                        search
                                        selection
                                        placeholder={props.moment == "import" ? (
                                          props.t(
                                            "delivery_form.port_terminal.placeholder"
                                          ) || "Port Terminal") : (
                                            props.t(
                                              "delivery_form.consignor.placeholder"
                                            ) || "Consignor Code"
                                          )
                                        }
                                        onChange={(name, data) =>
                                          setFieldValue(
                                            `deliveries[${index}].consignor_code`,
                                            data.value
                                          )
                                        }
                                        defaultValue={
                                          values.deliveries[index].consignor_code
                                        }
                                        options={consignors}
                                        error={
                                          getIn(
                                            errors,
                                            `deliveries[${index}].consignor_code`
                                          ) &&
                                            getIn(
                                              touched,
                                              `deliveries[${index}].consignor_code`
                                            )
                                            ? true
                                            : false
                                        }
                                      /><ModalCreateConsignor reFetchConsignor={getIntialCall} /></div>
                                    {
                                      <ErrorMessages
                                        name={`deliveries[${index}].consignor_code`}
                                        className="w3-text-red"
                                        trans={"delivery_form.consignor"}
                                      />
                                    }
                                  </Table.Cell>
                                  <Table.Cell>
                                    <label className="labelName">
                                      {props.moment == "import" ? (
                                        <>
                                          {props.t(
                                            "delivery_form.delivery_location.title"
                                          ) || "Delivery Location"}{" "}
                                          <MandatoryMark />
                                        </>
                                      ) : (
                                          <>
                                            {props.t(
                                              "delivery_form.consignee.title"
                                            ) || "Consignee"}{" "}
                                            <MandatoryMark />
                                          </>
                                        )}
                                    </label><br></br>
                                    <div className="ui action input">
                                      <Dropdown
                                        labeled={true}
                                        name={`deliveries[${index}].consignee_code`}
                                        clearable
                                        search
                                        style={{ width: "100%" }}
                                        selection
                                        placeholder={props.moment == "import" ? (
                                          props.t(
                                            "delivery_form.delivery_location.placeholder"
                                          ) || "Delivery Location"
                                        ) : (
                                            props.t(
                                              "delivery_form.consignee.placeholder"
                                            ) || "Consignee Code"
                                          )
                                        }
                                        onChange={(name, data) =>
                                          setFieldValue(
                                            `deliveries[${index}].consignee_code`,
                                            data.value
                                          )
                                        }
                                        defaultValue={
                                          values.deliveries[index].consignee_code
                                        }
                                        options={consignees}
                                        error={
                                          getIn(
                                            errors,
                                            `deliveries[${index}].consignee_code`
                                          ) &&
                                            getIn(
                                              touched,
                                              `deliveries[${index}].consignee_code`
                                            )
                                            ? true
                                            : false
                                        }
                                      /><ModalCreateConsignee reFetchConsignee={getIntialCall} /></div>
                                    {
                                      <ErrorMessages
                                        name={`deliveries[${index}].consignee_code`}
                                        trans={"delivery_form.consignee"}
                                      />
                                    }
                                  </Table.Cell>
                                  {Number(localStorage.getItem("customerNumber")) == 1158 ? (
                                    <>
                                      <Table.Cell>
                                        <Fieldmik
                                          component={MyInput}
                                          icon="thermometer quarter"
                                          iconPosition="left"
                                          style={{ paddingTop: "5.5px" }}
                                          label={
                                            props.t(
                                              "delivery_form.temperature_min.title"
                                            ) || "Temperature Minimum"
                                          }
                                          type="number"
                                          name={`deliveries[${index}].min_temp`}
                                          error={
                                            getIn(
                                              errors,
                                              `deliveries[${index}].min_temp`
                                            ) &&
                                              getIn(
                                                touched,
                                                `deliveries[${index}].min_temp`
                                              )
                                              ? true
                                              : false
                                          }
                                        />
                                        {
                                          <ErrorMessages
                                            name={`deliveries[${index}].min_temp`}
                                            trans={"delivery_form.temperature_min"}
                                          />
                                        }
                                      </Table.Cell>
                                      <Table.Cell>
                                        <Fieldmik
                                          component={MyInput}
                                          icon="thermometer quarter"
                                          iconPosition="left"
                                          style={{ paddingTop: "5.5px" }}
                                          label={
                                            props.t(
                                              "delivery_form.temperature_max.title"
                                            ) || "Temperature Maximum"
                                          }
                                          type="number"
                                          name={`deliveries[${index}].max_temp`}
                                          error={
                                            getIn(
                                              errors,
                                              `deliveries[${index}].max_temp`
                                            ) &&
                                              getIn(
                                                touched,
                                                `deliveries[${index}].max_temp`
                                              )
                                              ? true
                                              : false
                                          }
                                        />
                                        {
                                          <ErrorMessages
                                            name={`deliveries[${index}].max_temp`}
                                            trans={"delivery_form.temperature_max"}
                                          />
                                        }
                                      </Table.Cell>
                                    </>
                                  ) : (
                                      null
                                    )}
                                </Table.Row>
                                {props.moment ==
                                  "import" && (
                                    <>
                                      <Table.Row key={"import" + index}>
                                        <Table.Cell>
                                          <Fieldmik
                                            component={MyInput}
                                            style={{
                                              paddingTop: "5.5px",
                                              whiteSpace: "nowrap",
                                            }}
                                            label={
                                              props.t(
                                                "delivery_form.container_number.title"
                                              ) || "Container Number"
                                            }
                                            name={`deliveries[${index}].container_no`}
                                          />
                                        </Table.Cell>
                                        <Table.Cell>
                                          <FormUi.Field
                                            width={3}
                                            className="m-0 mb-2"
                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {props.t(
                                                "delivery_form.container_pickup_date.title"
                                              ) || "Container Pickup Date"}{" "}
                                              <MandatoryMark />
                                            </label>
                                          </FormUi.Field>
                                          <DateData
                                            // style={{ width: "100% !important" }}
                                            name={`deliveries[${index}].container_pickup_date`}
                                            autoComplete="off"
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            popperClassName="dateTime"
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            timeIntervals={5}
                                            customInput={
                                              <Input
                                                icon="time"
                                                // className="dateWidth"
                                                iconPosition="left"
                                              />
                                            }
                                          />
                                        </Table.Cell>
                                        <Table.Cell>
                                          <FormUi.Field
                                            width={3}
                                            className="m-0 mb-2"
                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {props.t(
                                                "delivery_form.container_return_date.title"
                                              ) || "Container Return Date"}{" "}
                                              <MandatoryMark />
                                            </label>
                                          </FormUi.Field>
                                          <DateData
                                            name={`deliveries[${index}].container_return_date`}
                                            autoComplete="off"
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            popperClassName="dateTime"
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            timeIntervals={5}
                                            customInput={
                                              <Input
                                                icon="time"
                                                // className="dateWidth"
                                                iconPosition="left"
                                              />
                                            }
                                          />
                                        </Table.Cell>
                                        {/* <Table.Cell>
                                          <FormUi.Field
                                            width={3}
                                            className="m-0 mb-2"
                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              Container Drop Location
                                            {props.t(
                                              "delivery_form.container_return_date.title"
                                            ) || "Container Drop Location"}{" "}
                                              <MandatoryMark />
                                            </label>
                                          </FormUi.Field>
                                          <Fieldmik name="container_drop_location" component={DropLocation} clearable />
                                        </Table.Cell> */}
                                        <Table.Cell>
                                          <FormUi.Field
                                            width={3}
                                            className="m-0 mb-2"
                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {props.t(
                                                "delivery_form.storage_expiration.title"
                                              ) || "Storage Expiration"}{" "}
                                              <MandatoryMark />
                                            </label>
                                          </FormUi.Field>
                                          <DateData
                                            name={`deliveries[${index}].storage_expiration_date`}
                                            autoComplete="off"
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            popperClassName="dateTime"
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            timeIntervals={5}
                                            customInput={
                                              <Input
                                                icon="time"
                                                // className="dateWidth"
                                                iconPosition="left"
                                              />
                                            }
                                          />
                                        </Table.Cell>
                                      </Table.Row>
                                      <Table.Row>
                                        <Table.Cell>
                                          <FormUi.Field
                                            width={3}
                                            className="m-0 mb-2"
                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {props.t(
                                                "delivery_form.demurrage_expiration.title"
                                              ) || "Demurrage Expiration"}{" "}
                                              <MandatoryMark />
                                            </label>
                                          </FormUi.Field>
                                          <DateData
                                            name={`deliveries[${index}].demurrage_expiration_date`}
                                            autoComplete="off"
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            popperClassName="dateTime"
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            timeIntervals={5}
                                            customInput={
                                              <Input
                                                icon="time"
                                                // className="dateWidth"
                                                iconPosition="left"
                                              />
                                            }
                                          />
                                        </Table.Cell>
                                        <Table.Cell>
                                          <FormUi.Field
                                            width={3}
                                            className="m-0 mb-2"
                                          >
                                            <label
                                              className="labelName"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              ATA
                                            {/* {props.t(
                                              "delivery_form.container_return_date.title"
                                            ) || "Storage Expiration"}{" "} */}
                                              <MandatoryMark />
                                            </label>
                                          </FormUi.Field>
                                          <DateData
                                            name={`deliveries[${index}].ata_date`}
                                            autoComplete="off"
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            popperClassName="dateTime"
                                            dateFormat="dd/MM/yyyy HH:mm"
                                            timeIntervals={5}
                                            customInput={
                                              <Input
                                                icon="time"
                                                // className="dateWidth"
                                                iconPosition="left"
                                              />
                                            }
                                            error={
                                              getIn(
                                                errors,
                                                `deliveries[${index}].ata_date`
                                              ) &&
                                                getIn(
                                                  touched,
                                                  `deliveries[${index}].ata_date`
                                                )
                                                ? true
                                                : false
                                            }
                                          />
                                          {
                                            <ErrorMessages
                                              name={`deliveries[${index}].ata_date`}
                                              trans={"delivery_form.ata_date"}
                                            />
                                          }
                                        </Table.Cell>
                                      </Table.Row>
                                    </>
                                  )}
                                <Table.Row key={`Invoice` + index}>
                                  <Table.Cell colSpan="6">
                                    <FieldArray
                                      key={`invoice_form` + index}
                                      name={`deliveries[${index}].invoices`}
                                      render={(deliveryInvoices) => (
                                        <React.Fragment key={index}>
                                          {values.deliveries[
                                            index
                                          ].invoices.map((invoice, i) => (
                                            <Table unstackable key={i}>
                                              <Table.Header>
                                                <Table.Row>
                                                  <Table.HeaderCell colSpan="2">
                                                    {props.t(
                                                      "invoice_form.title"
                                                    ) || "Invoice"}{" "}
                                                    {i + 1}
                                                  </Table.HeaderCell>
                                                  <Table.HeaderCell textAlign="right">
                                                    {i !== 0 ? (
                                                      <Button
                                                        basic
                                                        color="red"
                                                        type="button"
                                                        onClick={() =>
                                                          deliveryInvoices.remove(
                                                            i
                                                          )
                                                        }
                                                        size="mini"
                                                        icon
                                                      >
                                                        {" "}
                                                        <Icon
                                                          name="trash"
                                                          color="red"
                                                        />{" "}
                                                      </Button>
                                                    ) : (
                                                        <></>
                                                      )}
                                                  </Table.HeaderCell>
                                                </Table.Row>
                                              </Table.Header>
                                              <Table.Body>
                                                <Table.Row>
                                                  <Table.Cell>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_code.title"
                                                        ) || "Invoice No"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_no`}
                                                      type="text"
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_no`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_no`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_no`}
                                                        trans={
                                                          "invoice_form.invoice_code"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.tracking_number.title"
                                                        ) || "Quantity"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].tracking_number`}
                                                      type="text"
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].tracking_number`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].tracking_number`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].tracking_number`}
                                                        trans={
                                                          "invoice_form.tracking_number"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <label>
                                                      {props.t(
                                                        "invoice_form.invoice_date.title"
                                                      ) || "Invoice Date"}
                                                    </label><br></br>
                                                    <DateData
                                                      name={`deliveries[${index}].invoices[${i}].invoice_date`}
                                                      autoComplete="off"
                                                      showTimeSelect
                                                      timeFormat="HH:mm"
                                                      popperClassName="dateTime"
                                                      dateFormat="dd/MM/yyyy HH:mm"
                                                      timeIntervals={5}
                                                      customInput={
                                                        <Input
                                                          icon="time"
                                                          // className="dateWidth"
                                                          iconPosition="left"
                                                        />
                                                      }
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_date`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_date`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_date`}
                                                        trans={"invoice_form.invoice_date"}
                                                      />
                                                    }
                                                  </Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                  <Table.Cell>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.invoice_quantity.title"
                                                        ) || "Quantity"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].invoice_quantity`}
                                                      type="number"
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].invoice_quantity`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].invoice_quantity`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].invoice_quantity`}
                                                        trans={
                                                          "invoice_form.invoice_quantity"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "invoice_form.bl_no.title"
                                                        ) || "Bl_No"
                                                      }
                                                      name={`deliveries[${index}].invoices[${i}].bl_no`}
                                                      type="text"
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].invoices[${i}].bl_no`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].invoices[${i}].bl_no`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].invoices[${i}].bl_no`}
                                                        trans={
                                                          "invoice_form.bl_no"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                </Table.Row>
                                              </Table.Body>
                                            </Table>
                                          ))}
                                          <Button
                                            basic
                                            color="blue"
                                            className="m-2"
                                            type="button"
                                            onClick={() =>
                                              deliveryInvoices.push({
                                                invoice_code: "",
                                                invoice_date: "",
                                                invoice_quantity: "",
                                                tracking_number: ""
                                              })
                                            }
                                            size="mini"
                                          >
                                            {" "}
                                            {props.t(
                                              "invoice_form.action_button.add_more_invoice"
                                            ) || "Add More Invoices"}{" "}
                                          </Button>
                                        </React.Fragment>
                                      )}
                                    />
                                  </Table.Cell>
                                </Table.Row>
                                <Table.Row key={`product` + index}>
                                  <Table.Cell colSpan="6">
                                    <FieldArray
                                      key={`product_form` + index}
                                      name={`deliveries[${index}].products`}
                                      render={(deliveryProducts) => (
                                        <React.Fragment key={index}>
                                          {values.deliveries[
                                            index
                                          ].products.map((product, i) => (
                                            <Table unstackable key={i}>
                                              <Table.Header>
                                                <Table.Row>
                                                  <Table.HeaderCell colSpan="2">
                                                    {props.t(
                                                      "product_form.title"
                                                    ) || "Product"}{" "}
                                                    {i + 1}
                                                  </Table.HeaderCell>
                                                  <Table.HeaderCell textAlign="right">
                                                    {i !== 0 ? (
                                                      <Button
                                                        basic
                                                        color="red"
                                                        type="button"
                                                        onClick={() =>
                                                          deliveryProducts.remove(
                                                            i
                                                          )
                                                        }
                                                        size="mini"
                                                        icon
                                                      >
                                                        {" "}
                                                        <Icon
                                                          name="trash"
                                                          color="red"
                                                        />{" "}
                                                      </Button>
                                                    ) : (
                                                        <></>
                                                      )}
                                                  </Table.HeaderCell>
                                                </Table.Row>
                                              </Table.Header>
                                              <Table.Body>
                                                <Table.Row>
                                                  <Table.Cell>
                                                    <label>
                                                      {props.t(
                                                        "product_form.product_code.title"
                                                      ) || "Product Code"}
                                                    </label>
                                                    <Dropdown
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].product_code`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].product_code`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      name={`deliveries[${index}].products[${i}].product_code`}
                                                      placeholder={
                                                        props.t(
                                                          "product_form.product_code.placeholder"
                                                        ) || "Product Code"
                                                      }
                                                      clearable
                                                      style={{ width: "100%" }}
                                                      selection
                                                      search
                                                      onChange={(name, data) =>
                                                        setProductCodeAndProductName(
                                                          name,
                                                          data
                                                        )
                                                      }
                                                      defaultValue={
                                                        values.deliveries[index]
                                                          .products[i]
                                                          .product_code
                                                      }
                                                      options={products}
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].product_code`}
                                                        trans={
                                                          "product_form.product_code"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "product_form.product_name"
                                                        ) || "Product Name"
                                                      }
                                                      name={`deliveries[${index}].products[${i}].product_name`}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].product_name`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].product_name`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].product_name`}
                                                        trans={
                                                          "product_form.product_name"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <Fieldmik
                                                      component={MyInput}
                                                      style={{
                                                        paddingTop: "5.5px",
                                                      }}
                                                      label={
                                                        props.t(
                                                          "product_form.quantity.title"
                                                        ) || "Quantity"
                                                      }
                                                      name={`deliveries[${index}].products[${i}].quantity`}
                                                      type="number"
                                                      min={0}
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].quantity`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].quantity`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].quantity`}
                                                        trans={
                                                          "product_form.quantity"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                  <Table.Cell>
                                                    <label>
                                                      {props.t(
                                                        "product_form.product_category_id.title"
                                                      ) || "Product Code"}
                                                    </label>
                                                    <Dropdown
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].product_category_id`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].product_category_id`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      name={`deliveries[${index}].products[${i}].product_category_id`}
                                                      placeholder={
                                                        props.t(
                                                          "product_form.product_category_id.placeholder"
                                                        ) || "Product Category"
                                                      }
                                                      clearable
                                                      style={{ width: "100%" }}
                                                      selection
                                                      search
                                                      onChange={(name, data) =>
                                                        setFieldValue(`deliveries[${index}].products[${i}].product_category_id`, +data.value)
                                                      }
                                                      defaultValue={
                                                        `${values.deliveries[index]
                                                          .products[i]
                                                          .product_category_id}`
                                                      }
                                                      options={[
                                                        { key: "1", text: "Agro Food/ F&V", value: "1" },
                                                        { key: "2", text: "Butter", value: "2" },
                                                        { key: "3", text: "Confectionery", value: "3" },
                                                        { key: "4", text: "Dairy Products", value: "4" },
                                                        { key: "5", text: "Healthcare & Pharma", value: "5" },
                                                        { key: "6", text: "Ice Creams", value: "6" },
                                                        { key: "7", text: "Industrial Products", value: "7" },
                                                        { key: "8", text: "Meat", value: "8" },
                                                        { key: "9", text: "Others", value: "9" },
                                                        { key: "10", text: "Poultry", value: "10" },
                                                        { key: "11", text: "Quick Serve Restaurant", value: "11" },
                                                        { key: "12", text: "RTC (Ready to Cook)", value: "12" },
                                                        { key: "13", text: "Sea Food", value: "13" },
                                                        { key: "14", text: "Beverages", value: "14" },
                                                        { key: "15", text: "RTE (Ready to Eat)", value: "15" },
                                                      ]}
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].product_category_id`}
                                                        trans={
                                                          "product_form.product_category_id"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                  <Table.Cell>
                                                    <label>
                                                      {props.t(
                                                        "product_form.packaging_type_id.title"
                                                      ) || "Packaging Type"}
                                                    </label>
                                                    <Dropdown
                                                      error={
                                                        getIn(
                                                          errors,
                                                          `deliveries[${index}].products[${i}].packaging_type_id`
                                                        ) &&
                                                          getIn(
                                                            touched,
                                                            `deliveries[${index}].products[${i}].packaging_type_id`
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      name={`deliveries[${index}].products[${i}].packaging_type_id`}
                                                      placeholder={
                                                        props.t(
                                                          "product_form.packaging_type_id.placeholder"
                                                        ) || "Product Code"
                                                      }
                                                      clearable
                                                      style={{ width: "100%" }}
                                                      selection
                                                      search
                                                      onChange={(name, data) =>
                                                        setFieldValue(`deliveries[${index}].products[${i}].packaging_type_id`, +data.value)
                                                      }
                                                      defaultValue={
                                                        `${values.deliveries[index]
                                                          .products[i]
                                                          .packaging_type_id}`
                                                      }
                                                      options={[
                                                        { key: "1", text: "Carton Box", value: "1" },
                                                        { key: "2", text: "Gunny Bundle", value: "2" },
                                                        { key: "3", text: "Loose Cargo", value: "3" },
                                                        { key: "4", text: "Metal Box", value: "4" },
                                                        { key: "5", text: "Metal Drum", value: "5" },
                                                        { key: "6", text: "Plastic Crate", value: "6" },
                                                        { key: "7", text: "Plastic Drum", value: "7" },
                                                        { key: "8", text: "Wooden Box", value: "8" },
                                                      ]}
                                                    />
                                                    {
                                                      <ErrorMessages
                                                        name={`deliveries[${index}].products[${i}].packaging_type_id`}
                                                        trans={
                                                          "product_form.packaging_type_id"
                                                        }
                                                      />
                                                    }
                                                  </Table.Cell>
                                                </Table.Row>
                                              </Table.Body>
                                            </Table>
                                          ))}
                                          <Button
                                            basic
                                            color="blue"
                                            className="m-2"
                                            type="button"
                                            onClick={() =>
                                              deliveryProducts.push({
                                                product_code: "",
                                                product_name: "",
                                                quantity: "",
                                              })
                                            }
                                            size="mini"
                                          >
                                            {" "}
                                            {props.t(
                                              "product_form.action_button.add_more_product"
                                            ) || "Add More Products"}{" "}
                                          </Button>
                                        </React.Fragment>
                                      )}
                                    />
                                  </Table.Cell>
                                </Table.Row>
                              </Table.Body>
                            </Table>
                          ))}
                          <Modal.Actions>
                            <center>
                              <Button
                                size="mini"
                                type="button"
                                onClick={() =>
                                  // console.log('new delivery', arrayHelpers)
                                  addNewDelivery(arrayHelpers)
                                  // arrayHelpers.push({
                                  //   delivery_number: "",
                                  //   delivery_reference_no: "",
                                  //   consignor_code: "",
                                  //   consignee_code: "",
                                  //   min_temp: null,
                                  //   max_temp: null,
                                  //   container_no: "",
                                  //   container_pickup_date: "",
                                  //   container_return_date: "",
                                  //   products: [
                                  //     {
                                  //       product_code: "",
                                  //       product_name: "",
                                  //       quantity: "",
                                  //     },
                                  //   ],
                                  // })
                                }
                                basic
                                primary
                                icon
                              >
                                {" "}
                                <Icon name="plus" />{" "}
                                {props.t("action_button.new_delivery") ||
                                  "New Delivery"}{" "}
                              </Button>

                              <Button size="mini" primary type="submit">
                                {props.t("action_button.save") || "Save"}
                              </Button>

                              <Button
                                onClick={props.handleClose}
                                size="mini"
                                color="red"
                                type="button"
                              >
                                {" "}
                                {props.t("action_button.close") || "Close"}{" "}
                              </Button>
                            </center>
                          </Modal.Actions>
                        </>
                      )}
                    />
                  </Formiker>
                </Modal.Description>
              </Modal.Content>
            );
          }}
        ></Formik>
      </Modal>
    </div>
  );
};

const mapStateToPrps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToPrps, {
  createShipmentDispatcher,
  successAlertDispatcher,
})(translate("create_order")(ModalEditJobOrder));
